export default __webpack_public_path__ + "static/media/zukunf_lauft_s1.17508824.png";